import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
  BarElement,
  LinearScale,
  Title,
  CategoryScale,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";

// One-time chart.js element/scale registration (moved out of src/index.tsx so chart.js lands in
// the chart consumers' lazy chunks instead of the entry bundle). Import this module — for its side
// effect — from every component that renders a react-chartjs-2 chart.
ChartJS.register(
  RadialLinearScale,
  PointElement,
  ArcElement,
  LineElement,
  Filler,
  ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
);
